import { forwardRef, type InputHTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  /** Set true to color the border/ring rose for invalid state. */
  invalid?: boolean;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, invalid, type = 'text', ...props }, ref) => {
    return (
      <input
        ref={ref}
        type={type}
        aria-invalid={invalid || undefined}
        className={cn(
          'flex h-10 w-full rounded-md border bg-white px-3 py-2 text-sm text-ink-900',
          'placeholder:text-ink-400',
          'border-ink-200',
          'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-lavender-400 focus-visible:border-lavender-300',
          'disabled:cursor-not-allowed disabled:bg-ink-100 disabled:text-ink-500',
          'transition-colors',
          invalid && 'border-rose-300 focus-visible:ring-rose-300',
          className,
        )}
        {...props}
      />
    );
  },
);
Input.displayName = 'Input';
